export const getMenusFromStorage = () => {
  try {
    const raw = localStorage.getItem("menus");
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const getMenuByPath = (path) => {
  const menus = getMenusFromStorage();
  const clean = (p) => String(p || "").trim().toLowerCase();

  return menus.find((m) => clean(m?.url) === clean(path)) || null;
};

export const can = (path, action) => {
  const m = getMenuByPath(path);
  if (!m) return false;

  const flag = {
    create: "can_create",
    read: "can_read",
    update: "can_create", // ✅ changed
    delete: "can_delete",
  }[action];

  if (!flag) return false;
  return Number(m?.[flag]) === 1;
};
